import { Navigate, useRoutes } from "react-router-dom";
import { useCanTrade } from "services/permissions/useCanTrade";
import { PermissionMode } from "services/permissions/usePermission";
import { NavTabLayout } from "../NavTabLayout";
import { NavTabPath } from "./types";

interface NavTabRoutesProps {
  routes: NavTabPath[];
}

export const NavTabRoutes = ({ routes }: NavTabRoutesProps) => {
  const { userCanTrade } = useCanTrade(PermissionMode.SELECTED_ANY);

  const filteredRoutes = routes.filter((route) => {
    if (route.path === "trading") {
      return userCanTrade;
    }

    return true;
  });

  return useRoutes([
    {
      path: "",
      element: <NavTabLayout routes={filteredRoutes} />,
      children: filteredRoutes,
    },
    {
      path: "*",
      element: <Navigate to="overview" replace />,
    },
  ]);
};
